if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/component/accordion.scss';
import './faq.scss';
import 'bootstrap/js/dist/collapse';
